import buttonProStyle from "../templates/Button.style";
import buttonBaseStyle from "../templates/ButtonBase.style";
import buttonHzeroStyle from "../templates-hzero/Button.style";
var buttonData = {
  name: 'button',
  data: [{
    //大
    lgFontSize: 14,
    lgIconFontSize: 16,
    lgHeight: 28,
    //中
    fontSize: 12,
    height: 28,
    // button高度
    iconFontSize: 16,
    //小
    smHeight: 28,
    smIconFontSize: 16,
    //
    minWidth: '.68rem',
    smMinWidth: '.4rem',
    leftRightPadding: 12,
    radius: 2,
    defaultDisabledColor: '#A6ACBD',
    linktextDecoration: 'none',
    defaultIconPosition: 'relative'
  }],
  onlyTemplate: {
    pro: buttonProStyle,
    base: buttonBaseStyle,
    hzero: buttonHzeroStyle
  }
};
export default buttonData;